import baladeiro from './baladeiro.jpg';
import criticoGastronomico from './critico-gastronomico.jpg';
import cult from './cult.jpg';
import goodVibes from './good-vibes.jpg';
import praieiro from './praieiro.jpg';
import urbano from './urbano.jpg';
import parquesTematicos from './parques-tematicos.jpg';

export const ALL_TRAVEL_TYPES = {
  baladeiro,
  criticoGastronomico,
  cult,
  goodVibes,
  praieiro,
  urbano,
  parquesTematicos,
};
